module.exports = __webpack_public_path__ + "img/dnaReagent.11dbbc65.png";